import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import moment from 'moment';
import { links } from 'constants/links';
import { t } from 'utils';

import styles from './Footer.module.scss';

export interface IFooter extends HTMLAttributes<HTMLDivElement> {}

const Footer: FC<IFooter> = (props) => {
  const { className } = props;
  const rootClassName = classNames(styles.root, className);
  const currentYear = moment().format('YYYY');

  return (
    <footer className={rootClassName}>
      <div className={classNames('container', styles.footerContainer)}>
        <div className={styles.copyright}>
          &copy; {currentYear} TIMIFY a product of TerminApp GmbH
        </div>
        <div>
          <a className={styles.link} href={links.imprint} rel={'noreferrer'} target={'_blank'}>
            {t('footer.imprint')}
          </a>
          <a
            className={styles.link}
            href={links.termsAndConditions}
            rel={'noreferrer'}
            target={'_blank'}
          >
            {t('footer.terms')}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
